import { EncryptStorage } from 'encrypt-storage';
import Cookies  from 'universal-cookie';
const secretKey = 'mi-secreto-super-seguro';
const encryptStorage = new EncryptStorage(secretKey, {
    storageType: 'localStorage', // Puedes usar 'sessionStorage' si lo prefieres
});
const CerrarSesion = (resultado)=>{
      /*
        'intUserId' - "iAAafa"
        'strUserName' - "asA5AaSD"
        'blnUserEntityIsEmployee' - "AFeaASDAsaASD"
        'strCompanyBillingIdentifier' - "aSDrr4aS566A"
        'strCompanyFiscalIdentifier' - "adWWsDweiTR45Sa"
        'menuOptions' - "abfENEIKC23g5sF2345E23SADF2fFsiN"
        'intUserEntityId' - "3RFW6i4FgGsukB63Ugnb"
        'intUserEntityTypeId' - "3FInmAT7FGiiieS7dBVD"
        */
       
    const cookies  = new Cookies(); 
        cookies.remove('elh_id');
        cookies.remove('elr_fol');
        cookies.remove('elb_agl');
        cookies.remove( 'elhid');//28800000
        cookies.remove('elr_fol'); 
        cookies.remove('eltf');
        cookies.remove('algdId');
        cookies.remove('ebid-book');
        // Almacenar datos en localStorage
        
        /*
            localStorage.removeItem('iAAafa');
            localStorage.removeItem('asA5AaSD');
            localStorage.removeItem('AFeaASDAsaASD');
            localStorage.removeItem('aSDrr4aS566A'); 
            localStorage.removeItem('adWWsDweiTR45Sa');
            localStorage.removeItem('abfENEIKC23g5sF2345E23SADF2fFsiN');
            localStorage.removeItem('3RFW6i4FgGsukB63Ugnb');
            localStorage.removeItem('3FInmAT7FGiiieS7dBVD');
        */
        
        encryptStorage.getItem('ses'); 
        encryptStorage.removeItem('ese');
        encryptStorage.clear();

        //window.location.assign("/login");
}

export default CerrarSesion;